import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useAppSelector } from "@builder/store/store";
import { BuildNode } from "@common/build/types";

type ExcludeFn = (node: BuildNode, comparator?: any) => boolean;

const useExcludeFunction = () => {
    const node = useAppSelector(getSelectedNode);
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);

    const evaluate = (excludeFn?: ExcludeFn): boolean => {
        if (!excludeFn || !node) return false;

        switch (node.name) {
            case "smartTile":
                return excludeFn(node, cvMode);
            default:
                return false;
        }
    };

    return evaluate;
};

export default useExcludeFunction;
